function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { BLOCK_ID_USER_ACTIONS, BLOCK_ID_USER_AUTH, BLOCK_ID_USER_MAIN } from 'moduleBase/constants/menu';
import { ProfileInfo } from 'moduleBase/components/header/profile/ProfileInfo';
import { Menu } from 'moduleBase/components/header/profile/Menu';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import { transformMenuBlockData } from './helpers';
import { LangsMenu } from '../LangsMenu/LangsMenu';
import Actions from '../Actions/Actions';

var ProfileInfoContent = function ProfileInfoContent(_ref) {
  var userMenu = _ref.userMenu,
      hide = _ref.hide;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      submenu = _React$useState2[0],
      setSubmenu = _React$useState2[1];

  var isDesktop = useMediaIsDesktop();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProfileInfo, null), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list"
  }, /*#__PURE__*/React.createElement(Menu, {
    block: transformMenuBlockData(userMenu, BLOCK_ID_USER_MAIN),
    hide: hide
  }), /*#__PURE__*/React.createElement(LangsMenu, {
    submenu: submenu,
    setSubmenu: setSubmenu
  }), !isDesktop ? /*#__PURE__*/React.createElement(Actions, {
    hide: hide,
    frozen: userMenu.frozen,
    wait: userMenu.wait,
    action: userMenu.action
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list"
  }, /*#__PURE__*/React.createElement(Menu, {
    block: transformMenuBlockData(userMenu, BLOCK_ID_USER_ACTIONS),
    hide: hide
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list"
  }, /*#__PURE__*/React.createElement(Menu, {
    block: transformMenuBlockData(userMenu, BLOCK_ID_USER_AUTH),
    hide: hide,
    itemClassName: "dropdown-flat-list__item_light"
  })));
};

export { ProfileInfoContent };